// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share-download[data-v-2bbdd42d]{background-size:cover;position:relative}.share-download .down-btn[data-v-2bbdd42d]{width:74.666667vw;height:14.133333vw;position:fixed;bottom:8vw;left:12.533333vw}@media (orientation:landscape){.share-download .down-btn[data-v-2bbdd42d]{width:49.295775vw;height:9.330986vw;bottom:5.28169vw;left:8.274648vw}}", ""]);
// Exports
module.exports = exports;
